import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { ProductAttributeFilters } from '@/features/product-attributes/api'
import { ProductAttributesView } from '@/features/product-attributes/product-attributes'

export const Route = createFileRoute('/_authenticated/product-attributes')({
  validateSearch: (search: Record<string, unknown>): ProductAttributeFilters => ({
    search: typeof search.search === 'string' ? search.search : undefined,
  }),
  component: ProductAttributesRoute,
})

function ProductAttributesRoute() {
  const params = Route.useSearch()
  const navigate = useNavigate()
  return (
    <ProductAttributesView
      params={params}
      onParamsChange={(next) =>
        void navigate({ to: '/product-attributes', search: next, replace: true })
      }
    />
  )
}
